"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const ZoomInIcon = React.forwardRef(function ZoomInIcon(props, ref) {
    return (_jsxs(Icon, Object.assign({ ref: ref }, props, { children: [_jsx("circle", { cx: "11", cy: "11", r: "8" }), _jsx("path", { d: "M21 21l-4.35-4.35" }), _jsx("path", { d: "M11 8v6" }), _jsx("path", { d: "M8 11h6" })] })));
});
export default ZoomInIcon;
//# sourceMappingURL=zoom-in.js.map